import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { Form, Formik, FormikContextType } from "formik";
import { FormControl } from "../form-control";
import Button from "../button";
import Input from "../input";
import { createRef } from "react";
import useObservable from "@core/hooks/use-observable.hook";
import { createLinkSchemaValidation } from "@app/validations";
import { CreateLinkRequest } from "@app/types";
import LinkService from "@app/services/http/link.service";

function CreateLinkModal({ portalDialogRef }: PortalDialogProps) {
  const formRef = createRef<FormikContextType<CreateLinkRequest>>();

  const { subscribeUntilDestroy } = useObservable();

  const handleSubmit = (values: CreateLinkRequest) => {
    subscribeUntilDestroy(LinkService.createLink(values), (link) => {
      portalDialogRef.close({ link });
    });
  };

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren>
      <div className="w-[500px] sm:w-[500px] p-5">
        <div className="font-bold text-xl">Thêm Link</div>
        <Formik
          initialValues={{ link: "", level: "" }}
          validationSchema={createLinkSchemaValidation}
          innerRef={formRef}
          onSubmit={handleSubmit}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <div className="flex justify-between gap-5">
              <div className="flex-1">
                <div className="mt-3 flex-1">
                  <FormControl name="link">
                    <Input
                      className="mt-1 !max-w-none text-sm"
                      errorClassName="text-sm"
                      placeholder="Nhập link..."
                    />
                  </FormControl>
                </div>
                <div className="mt-3 flex-1">
                  <FormControl name="level">
                    <Input
                      type="number"
                      className="mt-1 !max-w-none text-sm"
                      errorClassName="text-sm"
                      placeholder="Nhập level..."
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <Button
              type="submit"
              label="Thêm"
              containerClassName="mt-5 mx-auto"
              width="fit-content"
              className="px-6 text-sm"
              labelClassName="font-bold"
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default CreateLinkModal;
